import { Doughnut, Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import useActiveAgreementCount from "../../CarrierAgreementMgmt/Agreements/hooks/useActiveAgreementCount";
import { useGetCarriers } from "../../CarrierAgreementMgmt/Carrier/hooks/useGetCarriers";
import { useGetCarriersCount } from "../../CarrierAgreementMgmt/Carrier/hooks/useGetCarriersCount";
ChartJS.register(ArcElement, Tooltip, Legend);

const CarrierChart = () => {
  const { data: activeAgreement } = useActiveAgreementCount();
  const { data: carrier } = useGetCarriersCount();

  const activeCarrier = Number(carrier?.[0]);
  const inactiveCarrier = Number(carrier?.[1]);

  let carrierSum = activeCarrier + inactiveCarrier;

  const carrierData = {
    labels: ["Active", "Inactive"],
    datasets: [
      {
        // label: ["Active", "Inactive"],
        data: [activeCarrier, inactiveCarrier],

        backgroundColor: ["#0078D7", "#EC4899"],
        borderRadius: 5,
        borderWidth: 5,
      },
    ],
  };
  const carrierOptions = {};
  return (
    <div className="">
      <div className="grid grid-cols-2 items-center">
        <div className="grid sm:grid-cols-1">
          <h1 className="text-sm text-tertiary font-semibold">
            Carrier Status
          </h1>
        </div>
        <div className="grid sm:grid-cols-1">
          <h4 className="text-right text-xs text-tertiary font-base">
            Total of{" "}
            <span className="text-base font-semibold">{carrierSum}</span>
          </h4>
        </div>
      </div>
      <div className="mt-8 flex justify-center">
        <Doughnut
          className=""
          data={carrierData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: false,
                //  position: "bottom",
                //   align: "center",
                //   labels: {
                //     usePointStyle: true,
              },
              // },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return ` ${context.label}: ${context.formattedValue}`;
                  },
                },
              },
            },
            offset: 0.5,
            maintainAspectRatio: false,
          }}
        />
      </div>
      <div className="flex items-center gap-2 mt-8 pt-6 justify-center flex-row">
        <div className="flex flex-row items-center">
          <div className="h-2 w-2 rounded-md bg-tabColorDarkBlue m-1" />
          <div className="inline-block text-xs4 font-normal">Active</div>
        </div>

        <div className="flex flex-row items-center">
          <div className="h-2 w-2 rounded-md bg-hsecondary m-1" />
          <div className="inline-block text-xs4 font-normal">Inactive</div>
        </div>
      </div>
    </div>
  );
};

export default CarrierChart;
